<template>
    <div
        class="tw-flex tw-items-center tw-gap-4 tw-my-10"
    >
        <div
            class="tw-w-16 tw-h-16 lg:tw-w-24 lg:tw-h-24 tw-flex-shrink-0 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-4xl tw-font-medium tw-font-inter tw-text-gray-500"
            :class="isAsiInquiry ? 'asi-step-circle' : 'tw-bg-red-300'"
        >
            {{ number }}
        </div>
        <div
            class="tw-flex-1 tw-content-center tw-text-lg"
        >
            <slot />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        name: "NextStepsSnippet",
        components: {
        },
        props: {
            number: {
                type: Number,
                required: true,
            },
        },
        computed: {
            ...mapGetters({
                isAsiInquiry: 'tour/isAsiInquiry',
            }),
        },
    }
</script>

<style scoped>
    /* ASI next-steps circle: subtle gold tint (--color-gold-alpha-2 from the
       asi-reisen.de theme), defined on .theme-asi and cascading in here. */
    .asi-step-circle {
        background-color: var(--color-gold-alpha-2);
        color: var(--color-gold-10);
    }
</style>